export function upload(data, progressCallback, source) {
    const config = {
        onUploadProgress: progressCallback ? function (progressEvent) {
            var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            progressCallback(percentCompleted);
        } : null,
        cancelToken: source ? source.token : null,
    };

    return axios.post(route('api.manage.file.upload'), data, config)
        .then(response => {
            return response.data;
        });
}
